import { render } from "./TablePanel.vue?vue&type=template&id=20e2700a&scoped=true"
import script from "./TablePanel.vue?vue&type=script&lang=js"
export * from "./TablePanel.vue?vue&type=script&lang=js"

import "./TablePanel.vue?vue&type=style&index=0&id=20e2700a&scoped=true&lang=scss"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e2700a"]])

export default __exports__